import ScrollRouteExport from './ScrollRoute';

export const ScrollRoute = ScrollRouteExport;



// WEBPACK FOOTER //
// ./src/components/Analytics/index.js